/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ProjectUserDto interface.
 */
export function instanceOfProjectUserDto(value) {
    return true;
}
export function ProjectUserDtoFromJSON(json) {
    return ProjectUserDtoFromJSONTyped(json, false);
}
export function ProjectUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'nominativo': json['nominativo'] == null ? undefined : json['nominativo'],
    };
}
export function ProjectUserDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'nominativo': value['nominativo'],
    };
}
